<template>
    <div
        class="m-week m-week--offer"
        ref="mWeek"
    >
        <div
            class="m-week__nav"
            :class="`m-week__nav--day${mobileDay}`"
        >
            <div
                class="m-week__navDay"
                @click="mobileDay = 1"
            >
                Poniedziałek
                <span
                    v-if="packagesAmount(0) > 0"
                    class="m-week__navDayAmount"
                >{{ packagesAmount(0) }}</span>
            </div>
            <div
                class="m-week__navDay"
                @click="mobileDay = 2"
            >
                Wtorek
                <span
                    v-if="packagesAmount(1) > 0"
                    class="m-week__navDayAmount"
                >{{ packagesAmount(1) }}</span>
            </div>
            <div
                class="m-week__navDay"
                @click="mobileDay = 3"
            >
                Środa
                <span
                    v-if="packagesAmount(2) > 0"
                    class="m-week__navDayAmount"
                >{{ packagesAmount(2) }}</span>
            </div>
            <div
                class="m-week__navDay"
                @click="mobileDay = 4"
            >
                Czwartek
                <span
                    v-if="packagesAmount(3) > 0"
                    class="m-week__navDayAmount"
                >{{ packagesAmount(3) }}</span>
            </div>
            <div
                class="m-week__navDay"
                @click="mobileDay = 5"
            >
                Piątek
                <span
                    v-if="packagesAmount(4) > 0"
                    class="m-week__navDayAmount"
                >{{ packagesAmount(4) }}</span>
            </div>
        </div>
        <div
            class="m-week__days"
            :class="`m-week__days--day${mobileDay}`"
        >
            <div
                v-for="(day, dayInWeek) in days"
                v-bind:key="dayInWeek"
                class="m-week__day"
                :class="{
                    'm-week__day--inactive': isDayDisabled(dayInWeek)
                }"
                :data-day-id="dayInWeek"
                @drop="onDrop($event, dayInWeek)"
                @dragover.prevent
            >
                <div class="m-week__dayHeader">
                    <p class="a-title a-title--small">{{ day.name }}</p>
                </div>
                <div
                    class="m-week__dayOrder"
                    v-for="(order, orderIdx) in dayOrder(dayInWeek)"
                    v-bind:key="orderIdx"
                >
                    <offer-product-box
                        :week-day-order="order"
                        :product="order.product"
                        :day-in-week="dayInWeek"
                        :address-id="order.addressId"
                    />
                    <hr class="a-hr" />
                </div>
                <div v-if="dayOrder(dayInWeek).length === 0">
                    <p class="m-week__dayEmpty">Brak produktów dla tego dnia</p>
                </div>
                <div
                    v-if="dragSamplePackageDayId === dayInWeek"
                    class="m-product m-product--sample"
                >
                    <figure class="m-product__image">
                        <img
                            src="@/assets/pack.jpg"
                            alt="product"
                            class="m-product__imageImg"
                        >
                    </figure>
                    <div>
                        <p class="m-product__title"></p>
                        <div class="m-product__data">
                            <p class="m-product__price"></p>
                            <p class="m-product__amount a-label"></p>
                        </div>
                    </div>
                </div>
                <div
                    class="m-week__alert m-week__alert--inactive"
                    v-if="isDayDisabled(dayInWeek)"
                >
                    <p class="m-week__alertText">
                        Ten dzień jest wyłączony w ofercie.
                    </p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import OfferProductBox from '@/components/offer/OfferProductBox'
export default {
    components: {
        OfferProductBox
    },
    data() {
        return {
            mobileDay: 1
        }
    },
    computed: {
        currentAddressId() {
            return this.$store.getters.currentAddressId
        },
        days() {
            return [
                {
                    name: 'Poniedziałek'
                }, {
                    name: 'Wtorek'
                }, {
                    name: 'Środa'
                }, {
                    name: 'Czwartek'
                }, {
                    name: 'Piątek'
                }
            ]
        },
        weekOrders() {
            return this.$store.getters.weekOrders
        },
        minimumValue() {
            return this.$store.getters.minimumValue
        },
        availibleDays() {
            // return days for given product
            const week = [
                {
                    day: 1,
                    is_active: false
                }, {
                    day: 2,
                    is_active: false
                }, {
                    day: 3,
                    is_active: false
                }, {
                    day: 4,
                    is_active: false
                }, {
                    day: 5,
                    is_active: false
                }
            ]
            const draggedPackage = this.getProduct(this.dragProductId)
            if(draggedPackage) {
                for(const day of draggedPackage.isodow) {
                    week.find(item => item.day === day).is_active = true
                }
            }
            return week
        },
        dragSamplePackageDayId() {
            return this.$store.getters.dragSamplePackageDayId
        },
        dragStatus() {
            return this.$store.getters.dragStatus
        },
        dragProductId() {
            return this.$store.getters.dragProductId
        },
        offerFeaturedPackages() {
            return this.$store.getters.offerFeaturedPackages
        }
    },
    methods: {
        weekDayOrderSumWithoutDiscount(day) {
            return this.$store.getters.weekDayOrderSumWithoutDiscount(day, this.currentAddressId)
        },
        dayOrder(dayInWeek) {
            return this.$store.getters.weekDayOrder(dayInWeek, this.currentAddressId)
        },
        dayOrderSum(dayInWeek) {
            return this.$store.getters.weekDayOrderSum(dayInWeek, this.currentAddressId)
        },
        packagesAmount(dayInWeek) {
            return this.weekOrders.filter(item => item.addressId === this.currentAddressId && item.dayInWeek === dayInWeek).length
        },
        isDayDisabled(dayInWeek) {
            if(this.dragStatus && typeof this.availibleDays === 'object' && Object.keys(this.availibleDays).length > 0) {
                return !this.availibleDays.find(item => item.day === dayInWeek + 1).is_active
            } else {
                return false
            }
        },
        getProduct(productId) {
            const packageInFeatures = this.offerFeaturedPackages.find(item => item.id === productId)
            let packageInCart = this.weekOrders.find(item => item.product.id === productId)
            packageInCart = packageInCart ? packageInCart.product : undefined
            return packageInFeatures || packageInCart
        },
        onDrop($event, dayInWeek) {
            if(!this.isDayDisabled(dayInWeek)) {
                const orderId = parseInt($event.dataTransfer.getData('orderId'))
                const productId = parseInt($event.dataTransfer.getData('productId'))
                const productIndex = this.$store.getters.offerFeaturedPackages.findIndex(product => product.id === +productId)
                const product = this.getProduct(productId)
                const cycleId = parseInt($event.dataTransfer.getData('cycleId'))
                if(product !== undefined && cycleId !== '') {
                    const productCycleId = isNaN(cycleId) ? product.cycleId : cycleId
                    this.$store.dispatch('applyProductToCart', {
                        dayInWeek: dayInWeek,
                        addressId: this.currentAddressId,
                        period: productCycleId === 0 ? product.approx_delivery_count : 1,
                        cycle: product.cycles[cycleId],
                        cycles: product.cycles,
                        cycleId: productCycleId,
                        product,
                        draggable: true,
                        amount: product.amount
                    })
                    if(productIndex !== -1) {
                        const featuredPackages = Array.from(this.offerFeaturedPackages)
                        featuredPackages.splice(productIndex, 1)
                        this.$store.dispatch('setOfferFeaturedPackages', featuredPackages)
                    }
                    if(!isNaN(orderId)) {
                        const oldAddressId = this.weekOrders[orderId].addressId
                        const oldDayInWeek = this.weekOrders[orderId].dayInWeek
                        const oldProductId = this.weekOrders[orderId].product.id
                        if(dayInWeek !== oldDayInWeek) {
                            // remove old
                            const toRemoveId = this.weekOrders.findIndex(item => item.addressId === oldAddressId && item.dayInWeek === oldDayInWeek && item.product.id === oldProductId)
                            this.$store.dispatch('applyProductToCart', {
                                dayInWeek: oldDayInWeek,
                                addressId: oldAddressId,
                                product: this.weekOrders[toRemoveId].product,
                                amount: 0
                            })
                        }
                    }
                }
            }
            this.$store.dispatch('dragReset')
        }
    },
    mounted() {
        const firstDay = parseInt(Math.min(...this.weekOrders.map(day => day.dayInWeek)))
        if(isFinite(firstDay)) {
            // add 1 because in api monday is 0, in app is 1
            this.mobileDay = firstDay + 1
        }
    }
}
</script>
